import { Pages } from "./types";

export const enum AnalyticsPageRuns {
  Runs = "Runs",
}

export const pagesRuns: Pages<AnalyticsPageRuns> = {
  [AnalyticsPageRuns.Runs]: ["Runs", "Runs view"],
};
